module.exports = __webpack_public_path__ + "media/images/wine-curve-812de9e367d3257f5706120a0c378a7e.webp";